var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-content-wrapper gray" }, [
    _c("div", { staticClass: "go-container mypage sub" }, [
      _c("div", { staticClass: "go-layout-wrap" }, [
        _c("div", { staticClass: "go-layout-header" }, [
          _c("div", { staticClass: "go-layout-path" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.myPage")))]),
            _vm._v(" "),
            _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.setting")))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-layout-title" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon",
                attrs: {
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                },
                on: {
                  click: function ($event) {
                    return _vm.roueToMyPage()
                  },
                },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-arrow-left" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "go-page-header-type2" }, [
              _c("div", { staticClass: "go-page-title" }, [
                _vm._v(_vm._s(_vm.$t("myPage.common.setting"))),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-layout-content" }, [
          _c("div", { staticClass: "go-panel go-panel-common setting" }, [
            _c("div", { staticClass: "go-panel-body setting" }, [
              _c("dl", [
                _c("dt", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("myPage.setting.tabTitle.theme"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("div", { staticClass: "go-form-group w-150" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentTheme,
                            expression: "currentTheme",
                          },
                        ],
                        staticClass: "go-form-control",
                        class: { notAllowClick: _vm.isLoading },
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.currentTheme = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.changeColorThemeAll,
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "system" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("myPage.setting.themeTab.optionText.sync")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "light" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("myPage.setting.themeTab.optionText.light")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "dark" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("myPage.setting.themeTab.optionText.dark")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-panel go-panel-common setting" }, [
            _c("div", { staticClass: "go-panel-body setting" }, [
              _c("dl", [
                _c("dt", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("myPage.setting.tabTitle.language"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("div", { staticClass: "go-form-group w-150" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentLanguage,
                            expression: "currentLanguage",
                          },
                        ],
                        staticClass: "go-form-control",
                        class: { notAllowClick: _vm.isLoading },
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.currentLanguage = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.changeLanguage()
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "ko" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "myPage.setting.languageTab.majorLanguage.optionText.korean"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "en" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "myPage.setting.languageTab.majorLanguage.optionText.english"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("dl", [
                _c("dt", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("myPage.common.referLanguage"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c(
                    "div",
                    { staticClass: "go-form-group" },
                    [
                      _c("MultiSelect", {
                        attrs: {
                          disable: _vm.isLoading,
                          options: _vm.contentLanguages,
                          placeholder: "Select content language",
                        },
                        model: {
                          value: _vm.contentLanguage,
                          callback: function ($$v) {
                            _vm.contentLanguage = $$v
                          },
                          expression: "contentLanguage",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }